// src/components/TextAreaField/TextAreaField.jsx
import React from "react";
import { Input } from "antd";
import "./TextAreaField.scss";

const { TextArea } = Input;

const TextAreaField = ({
  title,
  value,
  onChange,
  name,
  placeholder,
  required = false,
  errorText = "",
  helperText = "",
  maxLength,
  rows = 5,
}) => {
  const hasError = Boolean(errorText);

  return (
    <div className={`forminput ${hasError ? "has-error" : ""}`}>
      {title && (
        <span className="input-label">
          {title}
          {required && <span className="required-asterisk"> *</span>}
        </span>
      )}

      <div className="input-container">
        <TextArea
          className="textarea"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          showCount={Boolean(maxLength)}
        />
      </div>

      {hasError ? (
        <span className="input-error-text">{errorText}</span>
      ) : (
        helperText && <span className="input-helper-text">{helperText}</span>
      )}
    </div>
  );
};

export default TextAreaField;
